export const normalizeUrl = (url?: string): string =>
  String(url || "").replace(/^http:\/\//i, "https://");

export const setText = (
  root: ParentNode,
  selector: string,
  value: unknown,
) => {
  const element = root.querySelector<HTMLElement>(selector);
  if (!element) return;
  const next =
    value === undefined || value === null || value === "" ? "-" : String(value);
  if (element.textContent !== next) element.textContent = next;
};

export const setVisibleText = (
  root: ParentNode,
  selector: string,
  value: unknown,
  visible: boolean,
) => {
  const element = root.querySelector<HTMLElement>(selector);
  if (!element) return;
  if (element.hidden === visible) element.hidden = !visible;
  if (!visible) {
    if (element.textContent !== "") element.textContent = "";
    return;
  }
  const next =
    value === undefined || value === null || value === "" ? "-" : String(value);
  if (element.textContent !== next) element.textContent = next;
};

export const setTooltip = (
  root: ParentNode,
  selector: string,
  text: string,
) => {
  const element = root.querySelector<HTMLElement>(selector);
  if (!element) return;
  if (text) {
    if (element.dataset.gwdTooltip !== text) element.dataset.gwdTooltip = text;
    if (element.getAttribute("aria-label") !== text)
      element.setAttribute("aria-label", text);
    if (element.getAttribute("title") !== text)
      element.setAttribute("title", text);
  } else {
    if (element.dataset.gwdTooltip !== undefined) delete element.dataset.gwdTooltip;
    if (element.hasAttribute("aria-label")) element.removeAttribute("aria-label");
    if (element.hasAttribute("title")) element.removeAttribute("title");
  }
};

export const setImage = (
  root: ParentNode,
  selector: string,
  src?: string,
  alt = "",
) => {
  const image = root.querySelector<HTMLImageElement>(selector);
  if (!image) return;

  const fallbackSrc = String(image.dataset.fallbackSrc || "");
  const requestedSrc = normalizeUrl(src);
  const failedSrc = normalizeUrl(image.dataset.gwdFailedSrc);
  const safeSrc = requestedSrc && requestedSrc !== failedSrc ? requestedSrc : fallbackSrc;
  if (!safeSrc) {
    if (!image.hidden) image.hidden = true;
    if (image.hasAttribute("src")) image.removeAttribute("src");
    return;
  }

  if (image.hidden) image.hidden = false;
  if (image.alt !== alt) image.alt = alt;
  if (image.getAttribute("src") !== safeSrc) image.setAttribute("src", safeSrc);
};

export const setHtml = (
  root: ParentNode,
  selector: string,
  html: string,
) => {
  const element = root.querySelector<HTMLElement>(selector);
  if (!element) return;
  if (element.innerHTML !== html) element.innerHTML = html;
};

export const safeCssColor = (value?: string): string => {
  const color = String(value || "").trim();
  return /^(#[0-9a-f]{3,8}|rgba?\([^)]+\)|hsla?\([^)]+\))$/i.test(color)
    ? color
    : "";
};

export const setLeagueColor = (
  root: ParentNode,
  selector: string,
  color?: string,
) => {
  const element = root.querySelector<HTMLElement>(selector);
  if (!element) return;

  const safeColor = safeCssColor(color);
  if (safeColor) element.style.setProperty("--gwd-league-bg", safeColor);
  else element.style.removeProperty("--gwd-league-bg");
};
